<template>
  <div class="animated fadeIn mb-3">
    <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
      <i class="fal fa-spinner fa-spin" /> Instrument Data Loading...
    </div>
    <template v-else>
      <b-card no-body>
        <b-card-header>
          <span class="text-muted text-uppercase">Select Instrument(s)</span>
        </b-card-header>
        <b-card-body>
          <b-form-group class="mb-0">
            <b-row>
              <b-col
                v-for="(instrument, index) in instrument_collection"
                :key="index"
                cols="6"
              >
                <b-form-checkbox
                  :key="instrument.id"
                  :value="instrument.id"
                  v-model="checked"
                  :name="instrument.id"
                >
                  <strong>{{ instrument.name }}</strong>
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-form-group>
        </b-card-body>
      </b-card>
      <custom-table-pagination
        :options="per_page_options"
        :current_page="current_page"
        :per_page="per_page"
        :total_rows="total_rows"
        @update="updatePaginationData"
      />
    </template>
  </div>
</template>

<script>
import CustomTablePagination from "@/components/shared/CustomTablePagination";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const InstrumentRepository = LabRepositoryFactory.get("instrument");

export default {
  name: "TaskInstrumentForm",
  components: { CustomTablePagination },
  props: {
    task_instruments: {
      type: Array,
      defaultt: () => [],
    },
  },
  data() {
    return {
      loading: true,
      instrument_collection: null,
      current_page: 1,
      per_page: 10,
      total_rows: 10,
      per_page_options: [10, 15, 20],
    };
  },
  computed: {
    checked: {
      get() {
        return this.task_instruments;
      },
      set(value) {
        this.$emit("pickInstruments", value);
      },
    },
  },
  methods: {
    updatePaginationData({ field, value }) {
      this[field] = value;
      field === "per_page" && (this.current_page = 1);
      this.getInstruments();
    },
    updateFormData(data, total) {
      this.total_rows = total;
      this.instrument_collection = data;
    },
    async getInstruments() {
      this.loading = true;

      const { per_page, current_page } = this;

      const { data } = await InstrumentRepository.getSome({
        limit: per_page,
        page: current_page,
      });

      this.updateFormData(data.data, data.total);

      this.loading = false;
    },
  },
  created() {
    this.getInstruments();
  },
};
</script>
